import React from 'react';
import { render, Component } from 'preact';

export class AHDropdown extends Component {
    constructor(props) {
        super(props);
        this.filterWrapper = React.createRef();
        this.optionWrapper = React.createRef();

        this.state = {
            selectedOptions: [],
            isOptionsVisible: false,
        };
    }

    get options() {
        return this.props.filterOpts;
    }

    clearSelection = (e) => {
        e.stopPropagation();
        this.setState({
            selectedOptions: [],
            inputValue: '',
        });
    };

    toggleOptions = () => {
        this.setState((prevState) => ({
            isOptionsVisible: !prevState.isOptionsVisible,
        }));
    };

    handleClickOutside = (e) => {
        if (
            this.filterWrapper.current &&
            this.optionWrapper.current &&
            !this.filterWrapper.current.contains(e.target) &&
            !this.optionWrapper.current.contains(e.target)
        ) {
            this.setState({ isOptionsVisible: false });
        }
    };

    componentDidUpdate(_, prevState) {
        if (this.state.isOptionsVisible && !prevState.isOptionsVisible) {
            document.addEventListener('click', this.handleClickOutside);
        } else if (!this.state.isOptionsVisible && prevState.isOptionsVisible) {
            document.removeEventListener('click', this.handleClickOutside);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    getSelectedOptionLabel() {
        const [selected] = this.state.selectedOptions;
        if (selected?.label) {
            const label = selected.label;
            return label.length <= 30 ? label : label.substring(0, 30) + '..';
        }
        return '';
    }

    selectOption = (option) => {
        const { allowMultiple } = this.props.filterOpts;
        let selectedOptions = [...this.state.selectedOptions];

        if (allowMultiple) {
            if (this.isOptionSelected(option)) {
                selectedOptions = selectedOptions.filter(o => o.value !== option.value);
            } else {
                selectedOptions.push(option);
            }
        } else {
            selectedOptions = [option];
        }

        this.setState({
            selectedOptions,
            inputValue: selectedOptions.map(o => o.value).join(', '),
        });

        if (!allowMultiple) {
            this.props.onToggle?.(null);
        }
    };

    isOptionSelected = (option) => {
        return this.state.selectedOptions.some(o => o.value === option.value);
    };

    render() {
        const { selectedOptions, isOptionsVisible } = this.state;
        const { name } = this.props.filterOpts;
        const openIconClass = isOptionsVisible ? ' active' : '';

        return (
            <div className="ah-dropdown" ref={this.filterWrapper}>
                <p className="dropdown-label">{this.options.label}</p>
                <div className="ah-dropdown-content" onClick={this.toggleOptions}>
                    {selectedOptions.length === 0
                        ? 'Select an option'
                        : selectedOptions.length === 1
                            ? this.getSelectedOptionLabel()
                            : `${selectedOptions.length} selected`}

                    {selectedOptions.map((option, index) => (
                        <input
                            key={index}
                            type="hidden"
                            name={name}
                            value={option.value}
                        />
                    ))}

                    <div className="ah-dropdown-toggle">
                        {selectedOptions.length > 0 && !isOptionsVisible && (
                            <div className="clear-toggle" onClick={this.clearSelection}>
                                <svg aria-hidden="true" className="clear-selection-button__icon">
                                    <use xlinkHref="#icon-cross" />
                                </svg>
                            </div>
                        )}
                        <div onClick={this.toggleOptions}>
                            <svg aria-hidden="true" className={openIconClass}>
                                <use xlinkHref="#icon-chevron" />
                            </svg>
                        </div>
                    </div>
                </div>

                {isOptionsVisible && (
                    <div ref={this.optionWrapper} className="dropdown-component__options">
                        {this.options.options.map((option, index) => (
                            <div
                                key={index}
                                className={`dropdown-component__options__option ${
                                    this.isOptionSelected(option) ? 'option-selected' : ''
                                }`}
                                data-option-value={option.value}
                                onClick={() => this.selectOption(option)}
                            >
                                {option.label}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}







